import { createAction, props } from "@ngrx/store";

export const rejectFavoriteProjects = createAction(
  'Account.RejectFavoriteProjects',
  props<{ error: unknown }>()
);
